import { render, staticRenderFns } from "./AzrMJComponent.vue?vue&type=template&id=65a9c511&scoped=true"
import script from "./AzrMJComponent.vue?vue&type=script&lang=ts"
export * from "./AzrMJComponent.vue?vue&type=script&lang=ts"
import style0 from "./AzrMJComponent.vue?vue&type=style&index=0&id=65a9c511&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a9c511",
  null
  
)

export default component.exports